<template>
  <div>
    <Header></Header>
    <main>
      <div class="section section-alpha">
        <div class="container">
          <h1>Contact</h1>
        </div>
      </div>
      <div class="section section-beta">
        <div class="container">
          <p>
            <strong>CAP-Covid Survey Administrator</strong><br />
            Elizabeth Garrett Anderson Institute for Women's Health<br />
            University College London<br />
            Medical School Building<br />
            Huntley Street<br />
            London<br />
            WC1E 6AU
          </p>
          <p>
            <a href="mailto:cap-covid@ucl.ac.uk"
              >Email the Survey Administrator</a
            >
          </p>

          <p>
            <a href="https://www.ucl.ac.uk/womens-health/" target="_blank">
              EGA Institute for Women's Health Website</a
            >
          </p>
        </div>
      </div>
    </main>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";

export default {
  components: {
    Header,
    Footer
  }
};
</script>
